import PropTypes from 'prop-types'

function StatsCard({
  label,
  value,
  icon,
  iconBgColor = 'bg-primary-100 dark:bg-primary-900',
  iconColor = 'text-primary-600 dark:text-primary-400',
  className = '',
}) {
  return (
    <div
      className={`bg-surface-light dark:bg-surface-dark rounded-xl shadow-md dark:shadow-md p-6 ${className}`}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-neutral-600 dark:text-neutral-400">{label}</p>
          <p className="text-2xl font-bold text-neutral-900 dark:text-white mt-1">{value}</p>
        </div>
        <div className={`w-12 h-12 ${iconBgColor} rounded-lg flex items-center justify-center`}>
          <div className={`${iconColor} text-xl`}>{icon}</div>
        </div>
      </div>
    </div>
  )
}

StatsCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.node.isRequired,
  iconBgColor: PropTypes.string,
  iconColor: PropTypes.string,
  className: PropTypes.string,
}

export default StatsCard
